module.exports = "/_next/static/images/1c20f518ec63a3b24aaf54e8531d651d-roxinho-details-metalico-lg@3x.jpg";